import { createFileRoute } from "@tanstack/react-router";
import DocumentList from "@/components/_DocumentList";

export const Route = createFileRoute("/_auth/docs")({
  component: DocumentList,
});
